import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class StoreFilter {
  public paging: PaginationRequest = new PaginationRequest()
}
